/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { LeadCommentReferenceMeta } from './LeadCommentReferenceMeta';
import {
    LeadCommentReferenceMetaFromJSON,
    LeadCommentReferenceMetaFromJSONTyped,
    LeadCommentReferenceMetaToJSON,
    LeadCommentReferenceMetaToJSONTyped,
} from './LeadCommentReferenceMeta';
import type { LeadCommentReaction } from './LeadCommentReaction';
import {
    LeadCommentReactionFromJSON,
    LeadCommentReactionFromJSONTyped,
    LeadCommentReactionToJSON,
    LeadCommentReactionToJSONTyped,
} from './LeadCommentReaction';
import type { LeadCommentReferenceType } from './LeadCommentReferenceType';
import {
    LeadCommentReferenceTypeFromJSON,
    LeadCommentReferenceTypeFromJSONTyped,
    LeadCommentReferenceTypeToJSON,
    LeadCommentReferenceTypeToJSONTyped,
} from './LeadCommentReferenceType';

/**
 * 
 * @export
 * @interface LeadComment
 */
export interface LeadComment {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    comment?: object;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    created_by_user?: User;
    /**
     * 
     */
    reference_id?: string;
    /**
     * 
     */
    reference_type?: LeadCommentReferenceType;
    /**
     * 
     */
    reference_meta?: LeadCommentReferenceMeta;
    /**
     * Can be any value since a lead comment reference can be any valid record. e.g. LeadMedication or AnalysisResult
     */
    reference?: object;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    updatedAt?: string;
    /**
     * 
     */
    deletedAt?: string;
    /**
     * 
     */
    edited_at?: string;
    /**
     * 
     */
    parent_comment_id?: string;
    /**
     * 
     */
    comment_replies?: Array<LeadComment>;
    /**
     * 
     */
    reactions?: Array<LeadCommentReaction>;
    /**
     * Indicates if this comment was copied from an older lead that was combined into the current lead
     */
    copied_from_original_lead?: boolean;
}



/**
 * Check if a given object implements the LeadComment interface.
 */
export function instanceOfLeadComment(value: object): value is LeadComment {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    return true;
}

export function LeadCommentFromJSON(json: any): LeadComment {
    return LeadCommentFromJSONTyped(json, false);
}

export function LeadCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadComment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'lead_id': json['lead_id'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'created_by_user': json['created_by_user'] == null ? undefined : UserFromJSON(json['created_by_user']),
        'reference_id': json['reference_id'] == null ? undefined : json['reference_id'],
        'reference_type': json['reference_type'] == null ? undefined : LeadCommentReferenceTypeFromJSON(json['reference_type']),
        'reference_meta': json['reference_meta'] == null ? undefined : LeadCommentReferenceMetaFromJSON(json['reference_meta']),
        'reference': json['reference'] == null ? undefined : json['reference'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
        'edited_at': json['edited_at'] == null ? undefined : json['edited_at'],
        'parent_comment_id': json['parent_comment_id'] == null ? undefined : json['parent_comment_id'],
        'comment_replies': json['comment_replies'] == null ? undefined : ((json['comment_replies'] as Array<any>).map(LeadCommentFromJSON)),
        'reactions': json['reactions'] == null ? undefined : ((json['reactions'] as Array<any>).map(LeadCommentReactionFromJSON)),
        'copied_from_original_lead': json['copied_from_original_lead'] == null ? undefined : json['copied_from_original_lead'],
    };
}

export function LeadCommentToJSON(json: any): LeadComment {
    return LeadCommentToJSONTyped(json, false);
}

export function LeadCommentToJSONTyped(value?: LeadComment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'comment': value['comment'],
        'lead_id': value['lead_id'],
        'created_by_user_id': value['created_by_user_id'],
        'created_by_user': UserToJSON(value['created_by_user']),
        'reference_id': value['reference_id'],
        'reference_type': LeadCommentReferenceTypeToJSON(value['reference_type']),
        'reference_meta': LeadCommentReferenceMetaToJSON(value['reference_meta']),
        'reference': value['reference'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'deletedAt': value['deletedAt'],
        'edited_at': value['edited_at'],
        'parent_comment_id': value['parent_comment_id'],
        'comment_replies': value['comment_replies'] == null ? undefined : ((value['comment_replies'] as Array<any>).map(LeadCommentToJSON)),
        'reactions': value['reactions'] == null ? undefined : ((value['reactions'] as Array<any>).map(LeadCommentReactionToJSON)),
        'copied_from_original_lead': value['copied_from_original_lead'],
    };
}

